function _hasJong(value) {
  return (value.charCodeAt(value.length - 1) - 0xac00) % 28 > 0
}

export default (value: string) => {
  if(!value) return ''
  return _hasJong(value) ? `${value}이` : `${value}가`
}
